module.exports = __webpack_public_path__ + "img/tea.4b04ed21.png";